export interface CalcQuestionParams {
  minResponsesPerAccount?: number
  minAccountsGlobal?: number
}

export const CALC_QUESTION_PARAMS_DEFAULT: CalcQuestionParams = {
  minResponsesPerAccount: 10,
  minAccountsGlobal: 5
}

export interface BenchmarkDistribution {
  avg: number
  median: number
  total: number
  buckets: { min: number; max: number; count: number }[]
}
